module.exports = __webpack_public_path__ + "static/efreeti_chain-4bad4e5165c6595af20aef8f2dabe18d.jpeg";